module.exports = __webpack_public_path__ + "static/baseball.2f445b10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/baseball.jpg
// module id = 337
// module chunks = 35783957827783